import { parseAttachmentBody, type ConversationMessageItem } from "@/lib/conversations";
import ConversationAudioPlayer from "./ConversationAudioPlayer";
import ConversationMediaAttachment from "./ConversationMediaAttachment";

/**
 * Contenido de un mensaje del inbox: audio, foto, vídeo o documento si trae
 * adjunto de Meta; si no, el texto. Compartido por `ConversationMessageBubble`
 * (páginas de inbox) y `ConversationsPopup` (ventana flotante). Sin
 * `mediaUrl` (el inbox no tiene endpoint de adjuntos) se queda en el texto
 * guardado.
 */
export default function ConversationMessageContent({
  message,
  mediaUrl,
}: {
  message: Pick<ConversationMessageItem, "body" | "messageType" | "mediaId">;
  /** Endpoint del adjunto de ESTE mensaje (`…/:id/media/:messageId`). */
  mediaUrl?: string;
}) {
  if (mediaUrl && message.mediaId) {
    const type = message.messageType;
    if (type === "audio") {
      return <ConversationAudioPlayer mediaUrl={mediaUrl} />;
    }
    if (type === "image" || type === "video" || type === "document") {
      const parsed = parseAttachmentBody(message.body);
      return (
        <div className="space-y-1.5">
          <ConversationMediaAttachment
            mediaUrl={mediaUrl}
            kind={type}
            filename={parsed.filename ?? undefined}
            description={parsed.description ?? undefined}
          />
          {parsed.caption && <p>{parsed.caption}</p>}
        </div>
      );
    }
  }
  return <>{message.body}</>;
}
